import styled from 'styled-components';
import { BackToTop } from '@magalu/stereo-ui-icons';
export const BackToTopIcon = styled(BackToTop)`
  position: fixed;
  width: 63px;
  height: 63px;
  bottom: 75px;
  right: 26px;
  z-index: 99;
`;